import React from 'react'
import './FilterOptions.css'
const FilterOptions = () => {
    return (
      <div className="filter-container">
        <label className="filter-label">Filtrar por tipo</label>
        <div className="filter-content">
          <button>Todas</button>
          <button>Pagamentos</button>
          <button>Reservas</button>
          <button>Sistema</button>
          <button>Avisos</button>
        </div>
      </div>
    );
  };

  export default FilterOptions;